import { observable, action, makeObservable } from 'mobx';
import accountsAPI from "./api";

import {difference} from "lodash"

import * as mobx from 'mobx'

export default class AccountsStore {
  isLoading = false;

  loaded = false;

  accounts = [];

  // Callback functions to call with accounts after this is loaded
  onLoadedListeners = [];

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      loaded: observable,
      accounts: observable,
      loadAccounts: action,
      loadAdditionalAccounts: action,
      onAccountsLoaded: action.bound,
      onAdditionalAccountsLoaded: action.bound
    });
  }

  loadAccounts() {
    if(!this.accounts.length && !this.isLoading && !this.loaded){
      this.isLoading = true;
      return accountsAPI.getAccounts().then(this.onAccountsLoaded);
    }
    return Promise.resolve(this.accounts);
  }

  // In cases where a user lists accounts they have access to, but
  loadAdditionalAccounts(accountIds) {
    this.isLoading = true;
    const currentAccounts = mobx.toJS(this.accounts);
    const accountIdsNotAlreadyLoaded = difference(accountIds, currentAccounts.map(account => account.id));

    if (accountIdsNotAlreadyLoaded.length < 1) {
      // No need to make a network request to fetch zero additional accounts
      return new Promise(resolve => {
        resolve(currentAccounts);
      })
    } else {
      return accountsAPI.getAccountsByIds(accountIdsNotAlreadyLoaded)
        .then(this.onAdditionalAccountsLoaded)
    }
  }

  onAccountsLoaded(resp) {
    this.accounts = resp.accounts;
    this.onLoadedListeners.forEach(cb => cb(mobx.toJS(this.accounts)));
    this.isLoading = false;
    this.loaded = true;
    return this.accounts;
  }

  onAdditionalAccountsLoaded(resp) {
    this.accounts = [...this.accounts, ...resp.accounts];
    this.onLoadedListeners.forEach(cb => cb(mobx.toJS(this.accounts)));
    this.isLoading = false;
    this.loaded = true;
    return mobx.toJS(this.accounts);
  }

  search = (query) => {
    const accounts = this.accounts;
    const lowercase = query.toLowerCase();
    return accounts.filter(x => x.accountName.toLowerCase().includes(lowercase));
  };
}